import React from 'react'

import { Portlet, Row, Col, Button } from '_zari/core'

import { ZariContext } from '_zari/context'

import * as AsientoContableService from 'services/asientosContables.service'

import * as FormGroups from './formGroups'

const FormatoCambioDeCuenta = () => {
  const __zariContext = React.useContext(ZariContext)

  const [cuentaaCambiar, setCuentaaCambiar] = React.useState('')
  const [cuentaNueva, setCuentaNueva] = React.useState('')
  const [flagVerificar, setFlagVerificar] = React.useState(true)

  const clickCambiarCuenta = React.useCallback(() => {
    __zariContext.loader.open('Cambiando Cuenta...')
    AsientoContableService.cambiarCuenta({ cuentaaCambiar, cuentaNueva, flagVerificar })
      .then(({ data }) => {
        __zariContext.snack('success', 'Cuenta Cambiada con Exito')
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, cuentaNueva, cuentaaCambiar, flagVerificar])

  return (
    <Portlet>
      <Portlet.Header title='Cambio De Cuenta' />
      <Portlet.Body>
        <Row>
          <Col md={12}>
            <FormGroups.CuentaFormGroup texto='Cuenta a Cambiar' value={cuentaaCambiar} onChange={e => setCuentaaCambiar(e.target.value)} />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <FormGroups.CuentaFormGroup texto='Cuenta Nueva' value={cuentaNueva} onChange={e => setCuentaNueva(e.target.value)} />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <FormGroups.VerificarFormGroup value={flagVerificar} onChange={e => setFlagVerificar(prev => !prev)} />
          </Col>
        </Row>
        <Row>
          <Col md={12} className='text-right'>
            <Button onClick={clickCambiarCuenta}>Cambiar Cuenta</Button>
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(FormatoCambioDeCuenta)
